module.exports = __webpack_public_path__ + "static/media/OHLogo.64d22638.png";